import { SportsApiClient } from '@collector/sportsapi-client'

import {
  BaseIncident,
  QueueIncidentError,
  QueueIncidentStatus,
} from './BaseIncident.js'

export class DeleteIncident extends BaseIncident {
  readonly type = 'Delete'
  readonly isConfirmable = true
  readonly id: number
  uuid?: string

  constructor(
    eventId: number,
    id: number,
    uuid?: string,
    status?: QueueIncidentStatus,
    time?: number,
    error?: QueueIncidentError,
  ) {
    super(eventId, status, time, error)

    this.id = id
    this.uuid = uuid
  }

  public async process(sportsApiClient: SportsApiClient): Promise<string> {
    /**
     * DELETE sends `uuid` re-generated for every request (for better debugging)
     */
    this.uuid = BaseIncident.getUUID()

    const response = await sportsApiClient.Events.IncidentsQueue.delete(
      this.eventId,
      this.uuid,
      this.id,
    )

    return response.api.data.uuid
  }
}
